<template>
  <div>
    <Card>
        <Select v-model="id" value="id" filterable clearable @on-change="PaperCoreSelectHandleClick" @on-clear="PaperCoreClearHandle" :label-in-value="true" style="width:15rem">
            <Option v-for="item in PaperCoreList"
                    :value="item.Attributes_value_ID"
                    :key="item.Attributes_value_ID"
                    :label-in-value="true">{{ item.Name }}</Option>
        </Select>
        <Button type="info" style="margin-left:5rem" @click="NewBuildHandleClick">新增</Button>

        <PETRulesTable :PETRulesTableList="PETRulesTableList" @EditHandleClick="EditHandleClick" @DeleteHandleClick="DeleteHandleClick" style="margin-top:1rem"/>
    </Card>
    <Page :total="total" show-sizer show-elevator style="margin:1rem 0 8.3rem 0;text-align: center;" @on-change="PageChangeHandleClick" @on-page-size-change="PageSizeChangeHandleClick"/>

    <Drawer title="PET数据规则维护" width="80" :closable="false" v-model="isDrawer">
        <Form  :model="FormData" ref="formCustom" :rules="ruleCustom">
          <FormItem label="PET数量规则ID">
                <Input  v-model="FormData.Petid" value="FormData.Petid"  disabled/>
          </FormItem>
          <FormItem label="纸芯名称" prop="id">
                <Select v-model="FormData.id" value="FormData.id" filterable clearable :label-in-value="true" @on-change="FormDataIDSelectHandleClick">
                  <Option v-for="item in PaperCoreList"
                          :value="item.Attributes_value_ID"
                          :key="item.Attributes_value_ID"
                          >{{ item.Name }}</Option>
                </Select>
          </FormItem>
          <FormItem label="单重" prop="SingleWeight">
                <Input type="number"  v-model="FormData.SingleWeight" value="FormData.SingleWeight"/>
          </FormItem>
          <FormItem label="辅助数量" prop="AuxiliaryQuantity">
                <Input type="number" v-model="FormData.AuxiliaryQuantity" value="FormData.AuxiliaryQuantity"/>
          </FormItem>
        </Form>
        <div>
          <Button style="margin-right: 8px" @click="CancelHandleClick">取消</Button>
          <Button type="primary" @click="SubmitHandleClick('formCustom')">提交</Button>
        </div>
    </Drawer>
  </div>
</template>

<script>
import { GetPaperCoreListApi, GetBackstagePETRulesApi, ChangeBackstagePETRules } from '../../../api/PriceRules.js'
import PETRulesTable from './component/PETRulesTable.vue'
export default {
  name: 'PETRules',
  components: {
    PETRulesTable
  },
  data () {
    const validateid = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择纸芯'))
      }
      callback()
    }
    const validateSingleWeight = (rule, value, callback) => {
      if (value === 0) {
        callback(new Error('请填写单重'))
      }
      callback()
    }
    const validateAuxiliaryQuantity = (rule, value, callback) => {
      if (value === 0) {
        callback(new Error('请填写辅助数量'))
      }
      callback()
    }
    return {
      PaperCoreList: [],
      PaperCore: '',
      id: '',
      PETRulesTableList: [],
      total: 0,
      CurrentPage: 1,
      pageSize: 10,
      FormData: {
        Petid: '',
        id: '',
        PaperCore: '',
        SingleWeight: 0,
        AuxiliaryQuantity: 0
      },
      State: 0,
      isDrawer: false,
      ruleCustom: {
        id: [{ validator: validateid, trigger: 'blur' }],
        SingleWeight: [{ validator: validateSingleWeight, trigger: 'blur' }],
        AuxiliaryQuantity: [{ validator: validateAuxiliaryQuantity, trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    this.GetPaperCoreList()
    this.GetBackstagePETRules()
  },
  methods: {
    // 获取下拉列表数据
    GetPaperCoreList () {
      GetPaperCoreListApi().then(res => {
        if (res.IsSuccess) {
          this.PaperCoreList = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 获取数据表数据
    GetBackstagePETRules () {
      GetBackstagePETRulesApi(this.id, this.CurrentPage, this.pageSize).then(res => {
        if (res.IsSuccess) {
          this.total = res.Data.Table[0].total
          this.PETRulesTableList = res.Data.Table1
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 切换页数
    PageChangeHandleClick (res) {
      if (this.CurrentPage !== res) {
        this.CurrentPage = res
        this.GetBackstagePETRules()
      }
    },
    // 每页数据量改变
    PageSizeChangeHandleClick (res) {
      if (this.pageSize !== res) {
        this.pageSize = res
        this.GetBackstagePETRules()
      }
    },
    // 头部下拉选项被选择后
    PaperCoreSelectHandleClick (value) {
      this.id = value.value
      this.PaperCore = value.label
      this.CurrentPage = 1
      this.GetBackstagePETRules()
    },
    // 头部下拉被清空后
    PaperCoreClearHandle () {
      this.id = ''
      this.PaperCore = ''
      this.CurrentPage = 1
      this.GetBackstagePETRules()
    },
    // 抽屉纸芯被选择后回调
    FormDataIDSelectHandleClick (value) {
      this.FormData.id = value.value
      this.FormData.PaperCore = value.label
    },
    // 点击新增按钮触发事件
    NewBuildHandleClick () {
      this.State = 0
      this.FormData = {
        Petid: '',
        id: '',
        PaperCore: '',
        SingleWeight: 0,
        AuxiliaryQuantity: 0
      }
      this.isDrawer = true
    },
    // 点击编辑回调
    EditHandleClick (index) {
      this.State = 1
      this.FormData = {
        Petid: this.PETRulesTableList[index].Petid,
        id: this.PETRulesTableList[index].Attributes_value_ID,
        PaperCore: this.PETRulesTableList[index].PaperCore,
        SingleWeight: this.PETRulesTableList[index].SingleWeight,
        AuxiliaryQuantity: this.PETRulesTableList[index].AuxiliaryQuantity
      }
      this.isDrawer = true
    },
    // 点击删除按钮回调
    DeleteHandleClick (index) {
      this.State = 2
      this.FormData = {
        Petid: this.PETRulesTableList[index].Petid,
        id: '',
        PaperCore: '',
        SingleWeight: 0,
        AuxiliaryQuantity: 0
      }
      this.SubmissionData()
    },
    // 抽屉1取消回调
    CancelHandleClick () {
      this.isDrawer = false
      this.FormData = {
        Petid: '',
        id: '',
        PaperCore: '',
        SingleWeight: '',
        AuxiliaryQuantity: ''
      }
    },
    // 点击提交按钮回调
    SubmitHandleClick (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.SubmissionData()
        } else {
          this.$Message.error('Fail!')
        }
      })
    },
    // 提交数据规则变更数据
    SubmissionData () {
      ChangeBackstagePETRules({
        Petid: this.FormData.Petid,
        Attributes_value_ID: this.FormData.id,
        PaperCore: this.FormData.PaperCore,
        SingleWeight: this.FormData.SingleWeight,
        AuxiliaryQuantity: this.FormData.AuxiliaryQuantity,
        operation: this.State
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          this.isDrawer = false
          this.GetBackstagePETRules()
        } else {
          this.$Message.error(res.Message)
        }
      })
    }
  }
}
</script>
